/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Pipe, PipeTransform } from '@angular/core';
import { DriverTeam } from '@shared/models/driver-team';

@Pipe({
    name: 'userName',
    standalone: false
})
export class UserNamePipe implements PipeTransform {

  transform(value: string, args = {onlyInitials: false}): string {
    if (!args.onlyInitials) {
      return value;
    }
    const names = value.split(' ');
    return names.filter(name => name != null).map(name => {
      if (args.onlyInitials) {
        return name.substr(0, 1);
      }
      return name;
    }).join('');
  }
}
